// extracted by mini-css-extract-plugin
export var boldText = "_71-4";
export var checkboxContainer = "_71-6";
export var closeIcon = "_71-i";
export var container = "_71-0";
export var drawer = "_71-8";
export var drawerContent = "_71-9";
export var extraSmallText = "_71-5";
export var fulfillmentGroupTable = "_71-e";
export var largeText = "_71-3";
export var loadingSpinnerContainer = "_71-j";
export var mediumText = "_71-2";
export var narrow = "_71-f";
export var notificationLink = "_71-l";
export var packageCheckIconContainer = "_71-7";
export var slideoutHeaderActions = "_71-g";
export var slideoutHeaderActionsShifted = "_71-h";
export var slideoutHeaderContainer = "_71-a";
export var slideoutModal = "_71-c";
export var stickyHeaderWrapper = "_71-b";
export var table = "_71-k";
export var tableContainer = "_71-d";
export var tertiaryText = "_71-1";